// V1 保留原末四位字段，V2 使用与收款会员显示同形的组合识别信息。
export function phoneLastFour(value) {
  const text = String(value || '').trim();
  return /^[+0-9()\s*-]+$/.test(text) ? text.match(/([0-9]{4})$/)?.[1] || '' : '';
}

// 正常号码沿用 customerDisplay.maskMobile 的前三位/四星/末四位；不补造未知数字。
export function receiptMobile(value) {
  const text = String(value || '').trim().replace(/[()\s-]/g, '');
  if (/^\d{3}\*+\d{4}$/.test(text)) return `${text.slice(0, 3)}****${text.slice(-4)}`;
  if (/^\*+\d{4}$/.test(text)) return `****${text.slice(-4)}`;
  return /^\+?\d{8,}$/.test(text) ? `${text.slice(0, 3)}****${text.slice(-4)}` : '';
}

export function receiptIdentity(customer = {}, shipping = {}, tableName = '') {
  const type = String(shipping.type || '').trim();
  const pickup = ['自提', '自取', '到店自取'].includes(type);
  const dineIn = type === '堂食' || (!type && Boolean(tableName));
  const member = !customer.isGuest && customer._id !== '__guest__' && customer.type !== 'chain-guest' &&
    (customer.type === 'chain-member' || (!customer.type && Boolean(customer._id)));
  const mobile = value => typeof value === 'string' ? value : value?.phoneNumber;
  const phone = mobile(customer.person?.mobile) || mobile(customer.mobile) || customer.phoneNumber || customer.phone;
  const memberName = customer.person?.name || customer.name || '会员';
  return {
    tableName: dineIn ? tableName : '',
    pickupMemberName: pickup && member ? memberName : '',
    pickupMemberDisplay: pickup && member ? [memberName, receiptMobile(phone)].filter(Boolean).join(' ') : '',
    pickupPhoneTail: pickup && member ? phoneLastFour(phone) : '',
    deliveryName: !pickup && !dineIn ? shipping.customer?.name || '' : '',
    deliveryPhone: !pickup && !dineIn ? shipping.customer?.phone || '' : '',
    deliveryAddress: !pickup && !dineIn ? typeof shipping.address === 'string' ? shipping.address : [shipping.address?.region, shipping.address?.street].filter(Boolean).join(' ') : '',
  };
}
